import { useRef, useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Button } from '@rentflowdev/ui'

const SITE_EDITOR_URL =
	(import.meta.env.VITE_STUDIO_URL as string | undefined) ??
	'https://studio.rentflow.tech'

export const Route = createFileRoute('/_app/settings/site-builder')({
	component: SettingsSiteBuilderPage,
})

function SettingsSiteBuilderPage() {
	const { t } = useTranslation()
	const frameRef = useRef<HTMLIFrameElement>(null)
	const [bounced, setBounced] = useState(false)

	/**
	 * Студия без сессии отправляет фрейм обратно на наш адрес, и приложение
	 * рисовалось внутри самого себя — сайдбар, сводка и всё остальное вторым
	 * слоем. Пока фрейм на чужом источнике, прочитать его адрес нельзя, и это
	 * и есть признак нормальной работы: как только чтение удалось, значит
	 * студия вернула нас к себе домой.
	 */
	function handleLoad() {
		try {
			const href = frameRef.current?.contentWindow?.location.href
			if (href && new URL(href).origin === window.location.origin) setBounced(true)
		} catch {
			// Чужой источник — студия открылась, всё в порядке.
		}
	}

	if (bounced) {
		return (
			<div className="flex h-full flex-col items-center justify-center gap-3 p-6 text-center">
				<p className="text-sm text-(--color-muted-foreground)">
					{t('settings.siteBuilder.unavailable')}
				</p>
				<Button
					variant="outline"
					onClick={() => window.open(SITE_EDITOR_URL, '_blank', 'noopener,noreferrer')}
				>
					{t('settings.siteBuilder.openInNewTab')}
				</Button>
			</div>
		)
	}

	return (
		<iframe
			ref={frameRef}
			src={SITE_EDITOR_URL}
			title={t('settings.siteBuilder.title')}
			onLoad={handleLoad}
			className="h-full w-full border-0"
			allow="clipboard-read; clipboard-write; fullscreen"
		/>
	)
}
